import { render, staticRenderFns } from "./parameterInformationDescription.vue?vue&type=template&id=0d5720cf&scoped=true&"
import script from "./parameterInformationDescription.vue?vue&type=script&lang=js&"
export * from "./parameterInformationDescription.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d5720cf",
  null
  
)

export default component.exports